module.exports = __webpack_public_path__ + "img/sylvia.8b99f73d.png";